// Auto-grouping of identical products by Plotis + Aukštis + Tipas + Variklis + Spalva.
export const GROUP_PALETTE = [
    { name: "Amber", hex: "#f59e0b", badge: "bg-amber-500/25 text-amber-200 border border-amber-400/60" },
    { name: "Cyan", hex: "#06b6d4", badge: "bg-cyan-500/25 text-cyan-200 border border-cyan-400/60" },
    { name: "Emerald", hex: "#10b981", badge: "bg-emerald-500/25 text-emerald-200 border border-emerald-400/60" },
    { name: "Violet", hex: "#a855f7", badge: "bg-purple-500/25 text-purple-200 border border-purple-400/60" },
    { name: "Rose", hex: "#f43f5e", badge: "bg-rose-500/25 text-rose-200 border border-rose-400/60" },
    { name: "Indigo", hex: "#6366f1", badge: "bg-indigo-500/25 text-indigo-200 border border-indigo-400/60" },
    { name: "Teal", hex: "#14b8a6", badge: "bg-teal-500/25 text-teal-200 border border-teal-400/60" },
    { name: "Orange", hex: "#f97316", badge: "bg-orange-500/25 text-orange-200 border border-orange-400/60" },
];

const norm = (v) => String(v ?? "").trim().toLowerCase();

export function groupKey(row) {
    const w = norm(row.width);
    const h = norm(row.height);
    const t = norm(row.type);
    const m = norm(row.motor);
    const c = norm(row.color);
    if (!w || !h || !t) return null; // need at least dimensions + type to form a group
    return [w, h, t, m, c].join("|");
}

// Returns { rowColors: {rowId: {hex, badge, groupIndex}}, groups: [...] }
export function computeGroups(rows) {
    const keyToIndex = {};
    const groups = [];
    const rowColors = {};
    let next = 0;
    for (const row of rows) {
        const k = groupKey(row);
        if (!k) {
            rowColors[row.id] = null;
            continue;
        }
        if (!(k in keyToIndex)) {
            keyToIndex[k] = next;
            groups.push({
                index: next,
                key: k,
                color: GROUP_PALETTE[next % GROUP_PALETTE.length],
                rows: [],
                sample: row,
            });
            next += 1;
        }
        const gi = keyToIndex[k];
        groups[gi].rows.push(row);
        rowColors[row.id] = { ...GROUP_PALETTE[gi % GROUP_PALETTE.length], groupIndex: gi };
    }
    // only groups with 2+ identical rows are "duplicate" groups, but keep all for coloring
    return { rowColors, groups };
}

// Summary aggregation per distinct spec.
export function computeSummary(rows) {
    const map = {};
    for (const row of rows) {
        const k = groupKey(row);
        if (!k) continue;
        if (!map[k]) {
            map[k] = {
                key: k, width: row.width, height: row.height, type: row.type,
                motor: row.motor, color: row.color, totalQty: 0, positions: [], area: 0,
            };
        }
        const qty = Number(row.qty) || 0;
        map[k].totalQty += qty;
        if (row.blindPos || row.position) map[k].positions.push(row.blindPos || row.position);
        const w = Number(row.width) || 0;
        const h = Number(row.height) || 0;
        map[k].area += (w / 1000) * (h / 1000) * qty;
    }
    return Object.values(map);
}
